enum InvoiceDocumentType {
  COLLECTION_NOTICE = 'COLLECTION_NOTICE',
  DUNNING = 'DUNNING',
  ENFORCEMENT_WARNING = 'ENFORCEMENT_WARNING',
  INVOICE = 'INVOICE',
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  REMINDER = 'REMINDER',
}

export default InvoiceDocumentType;
